"use strict";
/**
 * Created on 10 15 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ExportedPriceWithValidity_1 = require("./ExportedPriceWithValidity");
/**
 * <p>Wrapper class encapsulating history of {@link ExportedPriceWithValidity} without specific context. According to context you should
 * manage history of exported prices according to your custom needs.</p>
 *
 * @author JMe
 */


var ExportedPriceHistory =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ExportedPriceHistory, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param prices List of {@link ExportedPriceWithValidity}. If empty, there was no exported price yet. This list should be kept updated
   *        each time there is some insertion/update/deletion of a price.
   */
  function ExportedPriceHistory(prices) {
    var _this;

    _classCallCheck(this, ExportedPriceHistory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceHistory).call(this));
    _this.prices = prices;
    return _this;
  }
  /**
   * <p>Inserts a new entry into {@link .prices}.</p>
   *
   * <p><b>Method does not check for prices overlap, it is up to caller to handle these cases.</b></p>
   *
   * @param price Price to insert
   * @return New copy of {@link ExportedPriceHistory} with a new state.
   */


  _createClass(ExportedPriceHistory, [{
    key: "insert",
    value: function insert(price) {
      var updatedPrices = this.prices.push(price);
      return this.copy('prices', updatedPrices);
    }
    /**
     * <p>Updates an existing price entry (found based on price validity start).</p>
     * <p>Price entries marked as deleted are ignored.</p>
     *
     * <p><b>Method does not check for prices overlap, it is up to caller to handle these cases.</b></p>
     *
     * @param newPrice This price replaces the previous one.
     * @return New copy of {@link ExportedPriceHistory} with a new state.
     * @throws Error If there is no matching price entry.
     */

  }, {
    key: "update",
    value: function update(newPrice) {
      var priceEntryToUpdateIdx = this.prices.findIndex(function (entry) {
        return entry.validFrom.isSame(newPrice.validFrom, 'day') && !entry.deleted;
      });

      if (priceEntryToUpdateIdx === -1) {
        throw Error("There is no price entry to update. Given update: ".concat(newPrice.toString(), ", prices:\n  ").concat(this.toString()));
      }

      var updatedPrices = this.prices.update(priceEntryToUpdateIdx, function () {
        return newPrice;
      });
      return this.copy('prices', updatedPrices);
    }
    /**
     * <p>Marks an entry selected by price validity start as deleted.</p>
     * <p>Price entries already marked as deleted are ignored.</p>
     *
     * @param validFrom Start of price interval validity
     * @return New copy of {@link ExportedPriceHistory} with a new state.
     * @throws Error If there is no matching price entry or it is already deleted.
     */

  }, {
    key: "markAsDeleted",
    value: function markAsDeleted(validFrom) {
      var priceEntryToUpdateIdx = this.prices.findIndex(function (entry) {
        return entry.validFrom.isSame(validFrom, 'day') && !entry.deleted;
      });

      if (priceEntryToUpdateIdx === -1) {
        throw Error("There is no price entry to mark as deleted. Given validFrom: ".concat(validFrom.toISOString(), ", prices:\n  ").concat(this.toString()));
      }

      var updatedPrices = this.prices.update(priceEntryToUpdateIdx, function (entry) {
        return entry.delete();
      });
      return this.copy('prices', updatedPrices);
    }
    /**
     * <p>Returns true if there are prices with overlapping validity. Deleted prices are ignored.</p>
     */

  }, {
    key: "hasOverlappingPrices",
    value: function hasOverlappingPrices() {
      var nonDeletedPrices = this.prices.filterNot(function (price) {
        return price.deleted;
      });
      return nonDeletedPrices.reduce(function (_ref, testedPrice) {
        var isOverlap = _ref.isOverlap,
            remainingPrices = _ref.remainingPrices;
        var newOverlap = remainingPrices.some(function (price) {
          return price.overlapsWith(testedPrice);
        });
        return {
          isOverlap: isOverlap || newOverlap,
          remainingPrices: remainingPrices.shift()
        };
      }, {
        isOverlap: false,
        remainingPrices: nonDeletedPrices.shift()
      }).isOverlap;
    }
    /**
     * Returns an end of validity of the last non-deleted validity interval.
     *
     * @returns Date, if the validity interval is closed; null, if it is opened; undefined, if the price is never valid.
     */

  }, {
    key: "getValidityEnd",
    value: function getValidityEnd() {
      return this.prices.reduce(function (maxValidTo, price) {
        if (price.deleted || maxValidTo === null) {
          return maxValidTo;
        }

        if (maxValidTo === undefined || price.validTo === null) {
          return price.validTo;
        }

        return price.validTo.isAfter(maxValidTo) ? price.validTo : maxValidTo;
      }, undefined);
    }
    /**
     * Returns an end of validity of the first deleted validity interval.
     *
     * @returns Date, if the validity interval is closed; null, if it is opened; undefined, if there are no deleted intervals.
     */

  }, {
    key: "getFirstDeletedValidityEnd",
    value: function getFirstDeletedValidityEnd() {
      return this.prices.reduce(function (minValidTo, price) {
        if (!price.deleted) {
          return minValidTo;
        }

        if (!minValidTo) {
          return price.validTo;
        }

        return price.validTo && price.validTo.isBefore(minValidTo) ? price.validTo : minValidTo;
      }, undefined);
    }
    /**
     * Returns the last valid validity interval validTo. Returns the first deleted validity interval validTo, if none of the intervals is
     * ever valid. Returns undefined, if there are not any intervals.
     *
     * @private
     */

  }, {
    key: "getLastValidPriceOrFirstDeletedPriceValidTo",
    value: function getLastValidPriceOrFirstDeletedPriceValidTo() {
      var lastValidTo = this.getValidityEnd();

      if (lastValidTo !== undefined) {
        return lastValidTo;
      }

      return this.getFirstDeletedValidityEnd();
    }
    /**
     * Returns the last valid price interval, if any.
     *
     * @returns Price with validity or undefined, if there are no exported price intervals.
     */

  }, {
    key: "getLastValidPrice",
    value: function getLastValidPrice() {
      return this.prices.reduce(function (maxValidToPrice, price) {
        if (price.deleted || maxValidToPrice && !maxValidToPrice.validTo) {
          return maxValidToPrice;
        }

        if (!maxValidToPrice || !price.validTo || price.validTo.isAfter(maxValidToPrice.validTo)) {
          return price;
        }

        return maxValidToPrice;
      }, undefined);
    }
    /**
     * Returns a start of validity of the first non-deleted validity interval.
     *
     * @returns Date or undefined, if the price is never valid.
     */

  }, {
    key: "getValidityStart",
    value: function getValidityStart() {
      return this.prices.reduce(function (minValidFrom, price) {
        if (price.deleted) {
          return minValidFrom;
        }

        if (minValidFrom === undefined) {
          return price.validFrom;
        }

        return price.validFrom.isBefore(minValidFrom) ? price.validFrom : minValidFrom;
      }, undefined);
    }
    /**
     * Returns true if any valid price interval contains the given date.
     *
     * @param date
     */

  }, {
    key: "isValidAt",
    value: function isValidAt(date) {
      return this.prices.reduce(function (isValid, price) {
        return isValid || !price.deleted && price.validFrom.isSameOrBefore(date) && (!price.validTo || price.validTo.isSameOrAfter(date));
      }, false);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[".concat(this.prices.map(function (price) {
        return price.toString();
      }).join('\n  '), "]");
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ExportedPriceHistory(mat.prices);
    }
  }]);

  return ExportedPriceHistory;
}(DomainObject_1.DomainObject);

exports.ExportedPriceHistory = ExportedPriceHistory;
ExportedPriceHistory.EMPTY = new ExportedPriceHistory(immutable_1.List());

ExportedPriceHistory.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ExportedPriceHistory.name);
  return {
    prices: builder.listOf(builder.obj('prices', ExportedPriceWithValidity_1.ExportedPriceWithValidity.schema, function (mat) {
      return ExportedPriceWithValidity_1.ExportedPriceWithValidity.fromDataDict(mat);
    }))
  };
}();